import $ from 'jquery';
require('../../../../../node_modules/sticky-kit/dist/sticky-kit.js');

export default () => {
    $('.mic-list-full.hide-for-medium-down').stick_in_parent({
        parent: '.fifteen-five-layout.collection-module',
        offset_top: 40
    });
};

